var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 16H0C0 16.5523 0.447715 17 1 17L1 16ZM21 16V17C21.5523 17 22 16.5523 22 16H21ZM21 4H22C22 3.44772 21.5523 3 21 3V4ZM12.5789 4L11.7604 4.57443C11.9476 4.84119 12.253 5 12.5789 5V4ZM10.4737 1L11.2922 0.425574C11.105 0.158808 10.7996 0 10.4737 0V1ZM19.5 2H20.5C20.5 1.44772 20.0523 1 19.5 1V2ZM0 1V16H2V1H0ZM1 17H21V15H1V17ZM22 16V4H20V16H22ZM10.4737 0H1V2H10.4737V0ZM13.3975 3.42557L11.994 1.42557L10.3569 2.57443L11.7604 4.57443L13.3975 3.42557ZM11.994 1.42557L11.2922 0.425574L9.65513 1.57443L10.3569 2.57443L11.994 1.42557ZM11.1754 3H19.5V1H11.1754V3ZM21 3H19.5V5H21V3ZM19.5 3H12.5789V5H19.5V3ZM18.5 2V4H20.5V2H18.5Z",
    fill: "#5BC5F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.ab5718f07c96c5234e05e2fdcf5cd59c.svg";
export { ForwardRef as ReactComponent };